'use strict';

import Component from 'generic.basecomponent';

export default class TouchButton extends Component {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {
        if ( 'ontouchstart' in window || navigator.msMaxTouchPoints ) {
            this.container.addEventListener("touchstart", this.addActiveClass);
            this.container.addEventListener("touchend", this.removeActiveClass);
            this.container.addEventListener("touchcancel", this.removeActiveClass);
        }
    }

    addActiveClass(e) {
        e.target.classList.add("is-active");
    }

    removeActiveClass(e) {
        let target = e.target;
        if( /is-active/g.test(target.className) ) {
            target.classList.remove("is-active");
        }
    }
}

TouchButton.id = 0;



// WEBPACK FOOTER //
// ./app/components/touch-button/js/generic.touch-button.js